import {html, svg} from '../lib/lit-html.js';
import {classMap} from '../lib/lit/directives/class-map.js';

function filterToggle(state){
	return html`
		<div class="ekm-search-page-toggle-filter-btn">
			<i class="shopui-icon shopui-icon-sliders"></i> Filter
		</div>
	`;
}

function gridViewIcon(state){
	const classes = {
		'u-opacity': !state.ui.gridView,
	};

	return svg`
		<svg class="ekm-search-view-toggle ${classMap(classes)}" width='20' height='17' viewBox='0 0 18 16' xmlns='http://www.w3.org/2000/svg'>
			<circle cx='2' cy='2' r='2' />
			<circle cx='9' cy='2' r='2' />
			<circle cx='16' cy='2' r='2' />
			<circle cx='16' cy='8' r='2' />
			<circle cx='9' cy='8' r='2' />
			<circle cx='2' cy='8' r='2' />
			<circle cx='2' cy='14' r='2' />
			<circle cx='9' cy='14' r='2' />
			<circle cx='16' cy='14' r='2' />
		</svg>
	`;
}

function listViewIcon(state){
	const classes = {
		'u-opacity': !state.ui.listView,
	};

	return svg`
		<svg class="ekm-search-view-toggle ${classMap(classes)}" width='20' height='17' viewBox='0 0 20 17' xmlns='http://www.w3.org/2000/svg'>
			<circle cx="1.87" cy="1.87" r="1.87" />
			<circle cx="1.87" cy="8.12" r="1.87" />
			<circle cx="1.87" cy="14.37" r="1.87" />
			<rect x="6.25" y="0.625" width="13.75" height="2.5" rx="0.6" />
			<rect x="6.25" y="6.875" width="13.75" height="2.5" rx="0.6" />
			<rect x="6.25" y="13.125" width="13.75" height="2.5" rx="0.6" />
		</svg>
	`;
}

function viewToggle(state){
	return html`
		<div class="ekm-search-page-toggle-view-style-btn">
			<span>View</span>
			${gridViewIcon(state)}
			${listViewIcon(state)}
		</div>
	`;
}

export function showingBar(state){
	var {
		search: {
			page, 
			totalItems, 
			items: {
				length
			}
		}
	} = state;

	var first = 1;
	var last = length;

	if (totalItems === 0){
		first = last = 0;
	}

	return html`
		<div class="ekm-search-page-showing-bar">
			<div class="ekm-search-page-toggle-filter">
				${state.showAttributeFilter ? filterToggle(state) : []}
			</div>
			<div class="ekm-search-page-showing-bar-text">
				Showing ${first} - ${last} of ${totalItems} products
			</div>
			<div class="ekm-search-page-showing-bar-views">
				${viewToggle(state)}
			</div>
		</div>
	`;
}

export function showingBarSkeleton(state){
	return html`
		<div class="ekm-search-page-showing-bar skeleton"></div>
	`;
}